import service from "@/store/services/fabricantes-service";

const state = {
  list: {},
  fabricante: {},
  meta: {},
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, fabricante) => {
    state.fabricante = fabricante;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
};

const actions = {
  list({ commit, dispatch }, params) {
    return service.list(params).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params).then((fabricante) => {
      commit("SET_RESOURCE", fabricante);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params).then((fabricante) => {
      commit("SET_RESOURCE", fabricante);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params).then((fabricante) => {
      commit("SET_RESOURCE", fabricante);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.pagination.total,
  fabricante: (state) => state.fabricante,
  dropdown: (state) => {
    /* state.list.map((fabricante) => console.log(fabricante)); */
    return state.list.map((fabricante) => ({
      id: fabricante.id,
      nombre: fabricante.nombre,
    }));
  },
};

const fabricantes = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default fabricantes;
